import { Process } from '@prisma/client';
import { Select as AntdSelect, SelectProps } from 'antd';

import { Picker } from '@app/web-components';

import { useProcessQuery } from './query';

export const Select = ({ loading, options, ...props }: SelectProps) => {
  const { search, getSelectProps } = Picker.usePicker();
  const { data, isFetching, isPending } = useProcessQuery<Process>({
    where: { name: { contains: search, mode: 'insensitive' } },
    orderBy: { name: 'asc' },
  });

  return (
    <AntdSelect
      {...getSelectProps({ ...props })}
      loading={isFetching || isPending}
      options={data?.data.filter((x) => !!x.name).map((x) => ({ value: x.id.toString(), label: x.name }))}
    />
  );
};
